

function compareDate(givenDate) {
    const inputDate = new Date(givenDate)
    const date = new Date()

    inputDate.setHours(0, 0, 0, 0)
    date.setHours(0, 0, 0, 0)

    if(inputDate > date) {
        return 'future'
    } else if (inputDate < date) {
        return 'past'
    } else {
        return 'present'
    }
}
export default compareDate;